import React, { Component } from 'react'
import { get } from "lodash"

import {
  goalWeightTypeData,
  getValidateKgMessage,
  getValidateLbsMessage,
  checkIsValidLbsGoalWeight,
  checkIsValidKgGoalWeight,
  checkIsChoosedGoalWeightType,
  isFailureLbsValidation,
  isFailureKgValidation,
} from "./static.goalWeightData"

import { withStepsState } from "../../../shared/containers/containerStepsState"

import ButtonFill from "../../../shared/items/controls/buttonFill"


class GoalWeightNextStepButton extends Component {
  componentDidUpdate() {
    const { data } = this.props

    if (checkIsChoosedGoalWeightType(data, goalWeightTypeData.lbs.value)) {
      this.checkvValidGoalWeightLbs()
    }

    else if (checkIsChoosedGoalWeightType(data, goalWeightTypeData.kg.value)) {
      this.checkvValidGoalWeightKg()
    }
  }

  checkvValidGoalWeightLbs() {
    const { data, onSetFailValidate, onSetSuccessValidate } = this.props

    if (isFailureLbsValidation(data))
      onSetFailValidate("goalWeight", getValidateLbsMessage(get(data, ["goalWeight", "value"], null)))

    else if (checkIsValidLbsGoalWeight(data))
      onSetSuccessValidate("goalWeight")
  }

  checkvValidGoalWeightKg() {
    const { data, onSetFailValidate, onSetSuccessValidate } = this.props

    if (isFailureKgValidation(data))
      onSetFailValidate("goalWeight", getValidateKgMessage(get(data, ["goalWeight", "value"], null)))

    else if (checkIsValidKgGoalWeight(data))
      onSetSuccessValidate("goalWeight")
  }

  render() {
    const { data, onToNextStep } = this.props

    return (
      <ButtonFill disabled={!get(data, ["goalWeight", "isValid"], false)} onClick={onToNextStep}>
        {this.props.children}
      </ButtonFill>
    )
  }
}

export default withStepsState(GoalWeightNextStepButton)